import { render, staticRenderFns } from "./ModalLengkapiProfil.vue?vue&type=template&id=1c825ce8&scoped=true&"
import script from "./ModalLengkapiProfil.vue?vue&type=script&lang=js&"
export * from "./ModalLengkapiProfil.vue?vue&type=script&lang=js&"
import style0 from "./ModalLengkapiProfil.vue?vue&type=style&index=0&id=1c825ce8&scoped=true&lang=css&"
import style1 from "./ModalLengkapiProfil.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c825ce8",
  null
  
)

export default component.exports